import React, { useState, useEffect } from 'react';
import { CardGroup, Card, Container } from 'react-bootstrap';
import { MdVerifiedUser } from "react-icons/md";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";
import useFirestore from '../hooks/useFirestore';
import { motion } from "framer-motion";
import ReactGA from "react-ga4";

import PhotoSkeleton from './skeletons/PhotoSkeleton';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import styles from "./ImageGrid2.module.css";

function ImageGrid({ SetSelectedImage }) {

    const [loading, setLoading] = useState(false);
    const { docs } = useFirestore('Portfolio');
    const [uniqueLabels, setUniqueLabels] = useState([]);
    

    useEffect(() => {
        setLoading(true);
        const fetchProject = async () => {
            try {
                // Your fetch code
                const uniqueLabelsData = Array.from(new Set(docs.map(doc => doc.Label)));

                setUniqueLabels(uniqueLabelsData);

            } catch (error) {
                console.error('Error fetching data: ', error);
            } 
            
        };

        setTimeout(() => {
            setLoading(false);
      
          fetchProject();
        }, 100);
       
        
    }, [docs]);

    const [activeTab, setActiveTab] = useState('all');
    const getDocumentCountByLabel = (label) => {

        return docs.filter((doc) => doc.Label === label).length;

    };

    const handleTabClick = (label) => {
        setActiveTab(label);
    };

    const handleImageClick = (doc) => {
        // Send an event to Google Analytics when an image is clicked
        ReactGA.event({
            category: "Image Selection",
            action: "Image Selected",
            label: doc.Title, // You can use the selected image's title as the label
        });
        SetSelectedImage(doc);
    };

    return (

        <div>
            <section className={styles['cutscene']}>

            </section>

            <div className={styles["portfo"]}>

                <Tabs  justify value={activeTab} className={styles['tabiu']} >
                    <TabsHeader
                        className={styles['tabHeader']}


                    >
                        <Tab
                            title={`All (${docs.length})`}
                            value="all"
                            onClick={() => handleTabClick('all')}
                            className={styles['filters']}
                        >
                            <span> All</span>
                            <span className={styles['count']}>{docs.length}</span>
                        </Tab>
                        {uniqueLabels.map(label => (
                            <Tab
                                title={`${label} (${getDocumentCountByLabel(label)})`}
                                key={label}
                                value={label}
                                onClick={() => handleTabClick(label)}
                                className={styles['filters']}
                            >
                                <span>{label}s</span>
                                <span className={styles['count']}>{getDocumentCountByLabel(label)}</span>
                            </Tab>
                        ))}
                    </TabsHeader>
                    
                        <TabsBody
                            animate={{
                                initial: { y: 250 },
                                mount: { y: 0 },
                                unmount: { y: 250 },
                            }}
                            className={styles['tabsBod']}
                        >

                            <TabPanel value="all" className={styles['surround']} >
                                <Container>
                                    {docs.map(doc => (
                                        <div className={styles["packs"]} key={doc.id}>
                                            <Row>

                                                <Col >
                                                    <CardGroup className={styles["cardhi"]}>
                                                        <motion.div
                                                            className={styles['imageCard']}
                                                            onClick={() => handleImageClick(doc)}
                                                            whileHover={{ top: "-10px", scale: 1.01 }}
                                                            layout
                                                        >
                                                            <Card.Body className={styles['imageCardBody']}>
                                                                <Card.Title className={styles['imageCardHead']}>
                                                                    <h2>{doc.Title}</h2>
                                                                    <div className={styles["circle"]}><div className={styles["circle-inner"]}></div></div>
                                                                </Card.Title>
                                                                <Card.Text className={styles['imageCardText']}>
                                                                    {/*
                                                                                Wrap the potentially error-prone code in a try-catch block
                                                                            */}
                                                                    {(() => {
                                                                        try {
                                                                            return (
                                                                                <React.Fragment>
                                                                                    <div className={styles['imageTe']}>{doc.Detail} <span><MdVerifiedUser /></span></div>
                                                                                    <div className={styles['imageID']}>{doc.ImageID}</div>
                                                                                </React.Fragment>
                                                                            );
                                                                        } catch (error) {
                                                                            // Handle the error gracefully
                                                                            console.error('Error:', error);
                                                                            // Render a fallback or error message
                                                                            return <p>Error: Failed to render data</p>;
                                                                        }
                                                                    })()}
                                                                </Card.Text>
                                                                <div className={styles["line"]}><div className={styles["line-inner"]}></div></div>
                                                                {loading ? <PhotoSkeleton /> :
                                                                    <div className={styles["imageHold2"]}>
                                                                        {(() => {
                                                                            try {
                                                                                if (doc.Label === 'Video') {
                                                                                    // Display video if Label is 'video'
                                                                                    return (
                                                                                        <video

                                                                                            muted
                                                                                            autoPlay
                                                                                            loop
                                                                                            className={styles['img']}
                                                                                            loading="lazy"
                                                                                        >
                                                                                            <source src={doc.PhotoUrl} type="video/mp4" />
                                                                                        </video>
                                                                                    );
                                                                                } else {
                                                                                    // Display image for other cases
                                                                                    return (
                                                                                        <motion.div
                                                                                        whileHover={{ filter: "saturate(0)" }}
                                                                                        className={styles['imgWrapper']} // optional extra styling
                                                                                      >
                                                                                        <LazyLoadImage
                                                                                          src={doc.PhotoUrl}
                                                                                          alt="Images"
                                                                                          className={styles['img']}
                                                                                          effect="blur" // adds blur effect while loading
                                                                                        />
                                                                                      </motion.div>
                                                                                    );
                                                                                }
                                                                            } catch (error) {
                                                                                // Handle the error gracefully
                                                                                console.error('Error:', error);
                                                                                // Render a fallback or error message
                                                                                return <p>Error: Failed to render data</p>;
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                }
                                                            </Card.Body>
                                                        </motion.div>
                                                    </CardGroup>
                                                </Col>

                                            </Row>
                                        </div>
                                    ))}
                                </Container>
                            </TabPanel>
                            {uniqueLabels.map(label => (
                                <TabPanel key={label} value={label} className={styles['surround']}
                                >
                                    <Container>
                                        {docs
                                            .filter(doc => doc.Label === label)
                                            .map(doc => (
                                                <div className={styles["packs"]} key={doc.id}>
                                                    <Row>

                                                        <Col >
                                                            <CardGroup className={styles["cardhi"]}>
                                                                <motion.div
                                                                    className={styles['imageCard']}
                                                                    onClick={() => handleImageClick(doc)}
                                                                    layout
                                                                >
                                                                    <Card.Body className={styles['imageCardBody']}>
                                                                        <Card.Title className={styles['imageCardHead']}>
                                                                            <h2>{doc.Title}</h2>
                                                                            <div className={styles["circle"]}><div className={styles["circle-inner"]}></div></div>
                                                                        </Card.Title>
                                                                        <Card.Text className={styles['imageCardText']}>
                                                                            {/*
                                                                                Wrap the potentially error-prone code in a try-catch block
                                                                            */}
                                                                            {(() => {
                                                                                try {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <div className={styles['imageTe']}>{doc.Detail} <span><MdVerifiedUser /></span></div>
                                                                                            <div className={styles['imageID']}>{doc.ImageID}</div>
                                                                                        </React.Fragment>
                                                                                    );
                                                                                } catch (error) {
                                                                                    // Handle the error gracefully
                                                                                    console.error('Error:', error);
                                                                                    // Render a fallback or error message
                                                                                    return <p>Error: Failed to render data</p>;
                                                                                }
                                                                            })()}
                                                                        </Card.Text>
                                                                        <div className={styles["line"]}><div className={styles["line-inner"]}></div></div>
                                                                        {loading ? <PhotoSkeleton /> :
                                                                            <div className={styles["imageHold2"]}>
                                                                                {(() => {
                                                                                    try {
                                                                                        if (doc.Label === 'Video') {
                                                                                            // Display video if Label is 'video'
                                                                                            return (
                                                                                                <video

                                                                                                    muted
                                                                                                    autoPlay
                                                                                                    loop
                                                                                                    className={styles['img']}
                                                                                                    loading="lazy"
                                                                                                >
                                                                                                    <source src={doc.PhotoUrl} type="video/mp4" />
                                                                                                </video>
                                                                                            );
                                                                                        } else {
                                                                                            // Display image for other cases
                                                                                            return (
                                                                                                <motion.div
                                                                                                whileHover={{ filter: "saturate(0)" }}
                                                                                                className={styles['imgWrapper']} // optional extra styling
                                                                                              >
                                                                                                <LazyLoadImage
                                                                                                  src={doc.PhotoUrl}
                                                                                                  alt="Images"
                                                                                                  className={styles['img']}
                                                                                                  effect="blur" // adds blur effect while loading
                                                                                                />
                                                                                              </motion.div>
                                                                                            );
                                                                                        }
                                                                                    } catch (error) {
                                                                                        // Handle the error gracefully
                                                                                        console.error('Error:', error);
                                                                                        // Render a fallback or error message
                                                                                        return <p>Error: Failed to render data</p>;
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                        }
                                                                    </Card.Body>
                                                                </motion.div>
                                                            </CardGroup>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            ))}
                                    </Container>
                                </TabPanel>
                            ))}
                        </TabsBody>

                  

                </Tabs>

            </div>
        </div>

    );
}

export default ImageGrid;
